export const FILE_UPLOAD = {
  uploadFileSizeLimit: 30,
  eKYCFileMinSizeLimit: 0,
  eKYCFileMaxSizeLimit: 10,
};
